import styled from "styled-components";

export const Legend = styled.div`
  position: absolute;
  li span {
    width: 10px;
    height: 9px;
    display: inline-block;
    margin: 0 5px 8px 0;
    vertical-align: -9.4px;
  }
  ul {
    flex-direction: column;
    list-style: none;
    font: 12px Verdana;
    white-space: nowrap;
  }
  li {
    height:12px;
    float:left;
    list-style-type: none;  
    width:218px;
    flex: wrap;
    background-repeat: no-repeat;
    background-position: center 30px;
    text-align: left;
  }
`;

export const PieContainer = styled.div`
  display: flex;
`;